import { useState, useEffect } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import {
  UPDATE_SEASON,
  GET_SEASONS_BY_COMPETITION_ID,
  GET_SEASON,
} from "../../GraphQL/Season";
import useNotification from "../../hooks/useNotification.js";

const EditSeasonDialog = (props) => {
  const [season, setSeason] = useState(props.season);
  const { notifySuccess } = useNotification();

  useEffect(() => {
    setSeason(props.season);
  }, [props]);

  const isValid =
    !!(season?.name?.trim()) && !!(season?.startDate) && !!(season?.endDate);

  const [updateSeason, { loading, error }] = useMutation(UPDATE_SEASON, {
    variables: {
      id: season.id,
      name: season.name,
      startDate: season.startDate,
      endDate: season.endDate,
    },
    refetchQueries: [GET_SEASONS_BY_COMPETITION_ID, GET_SEASON],
    onCompleted: () => { notifySuccess("Season updated."); props.setOpen(false); },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" && isValid) {
            updateSeason();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Season"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <TextField
            data-testid="name"
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={props.season.name}
            onChange={(e) => {
              setSeason({ ...season, name: e.target.value });
            }}
            InputProps={{ inputProps: { maxLength: 20 } }}
            helperText={`${season?.name?.length ?? 0}/20`}
          />
          <TextField
            data-testid="startDate"
            margin="dense"
            id="startDate"
            label="Start Date"
            type="date"
            fullWidth
            variant="standard"
            defaultValue={props.season.startDate}
            onChange={(e) => {
              setSeason({ ...season, startDate: e.target.value });
            }}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            data-testid="endDate"
            margin="dense"
            id="endDate"
            label="End Date"
            type="date"
            fullWidth
            variant="standard"
            defaultValue={props.season.endDate}
            onChange={(e) => {
              setSeason({ ...season, endDate: e.target.value });
            }}
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveEditSeasonDialogButton"
            variant="contained"
            onClick={() => updateSeason()}
            disabled={loading || !isValid}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Update"
            )}
          </Button>
          <Button
            data-testid="closeEditSeasonDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default EditSeasonDialog;
